import React from "react";
import {Heading, Text, View} from "@unibuddy/patron";
import {useTranslation} from "@unibuddy/intl";

import {INTL_ENTER_NEW_PASSWORD, INTL_RESET_PASSWORD} from "../../../../translations/passwordReset";
import {IntlNamespaces} from "../../../../translations/types";
import {UnibuddyLogoInlineSvg} from "../../../../widgets/modules/RegisterNew/components/UnibuddyLogoInlineSvg";

export function ResetPasswordHeading() {
    const {t} = useTranslation(IntlNamespaces.PASSWORD_RESET);
    const titleText = t(
        `${IntlNamespaces.PASSWORD_RESET}:${INTL_RESET_PASSWORD.key}`,
        INTL_RESET_PASSWORD.defaultValue,
    );

    return (
        <View gap="small-medium" alignItems="center">
            <UnibuddyLogoInlineSvg />
            <Heading size="xxsmall" level={1}>
                {titleText}
            </Heading>
            <Text size="small">
                {t(INTL_ENTER_NEW_PASSWORD.key, INTL_ENTER_NEW_PASSWORD.defaultValue)}
            </Text>
        </View>
    );
}
